import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ExpenseView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState('');
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];

  useEffect(() => {
        setPermission(FindModuleById(251)); 
        console.log(permission);
    axios
      .get(`/employees/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.employee);
          const currencydetail = primaryCurrency.find(item => item.value === response.data.data.employee.currency) || null;
          setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');

        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  if(value.profile_picture){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
        region: AWS_DEFAULT_REGION,
        signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.profile_picture};
    var user_iamge = s3.getSignedUrl('getObject', params);
    
}

  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Employee View</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/employees">Employees</Link>
                    </li>
                    <li className="breadcrumb-item active">View</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Employee Information</h4>
                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">Profile Image</th>
                        <td className="p-3">
                        <img
                                className="avatar-img"
                                src={user_iamge}
                                alt="Profile Image"
                                width={200}
                                height={200}
                              />
                          </td>
                      </tr>
                    <tr>
                        <th className="p-3">First Name</th>
                        <td className="p-3">{value.first_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Last Name</th>
                        <td className="p-3">{value.last_name}</td>
                      </tr>
                        <tr>
                        <th className="p-3">Gender</th>
                        <td className="p-3">{value.gender}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Phone Number</th>
                        <td className="p-3">{value.phone_number}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Position</th>
                        <td className="p-3">{value.position}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Date Of Birth</th>
                        <td className="p-3">
                            {value.date_of_birth
                              ? new Date(value.date_of_birth).toLocaleDateString('en-GB') // "22/09/2024"
                                  .replace(/\//g, '-') // Replace slashes with dashes
                              : ''}
                          </td>

                      </tr>
                      <tr>
                        <th className="p-3">Employment  Date</th>
                        <td className="p-3">
                          {value.employment_date
                            ? new Date(value.employment_date).toLocaleDateString('en-GB') // "22/09/2024"
                                .replace(/\//g, '-') // Replace slashes with dashes
                            : ''}
                        </td>

                      </tr>
                      <tr>
                        <th className="p-3">Join Date</th>
                        <td className="p-3">
                        {value.join_date
                          ? new Date(value.join_date).toLocaleDateString('en-GB') // "22/09/2024"
                              .replace(/\//g, '-') // Replace slashes with dashes
                          : ''}
                      </td>

                      </tr>
                      
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.emp_location?value.emp_location.title: ""}
                        </td>
                      </tr>
                       <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Family Situation</th>
                        <td className="p-3">
                          {value.emp_family_status?value.emp_family_status.title: ""}
                        </td>
                      </tr>

                      <tr>
                        <th className="p-3">Employee Status</th>
                        <td className="p-3">
                          {value.emp_status?value.emp_status.title: ""}
                        </td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Salary Netto</th>
                        <td className="p-3">{parseFloat(value.salary_netto).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Salary Brutto</th>
                        <td className="p-3">{parseFloat(value.salary_brutto).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Salary</th>
                        <td className="p-3">{parseFloat(value.total_salary).toFixed(2)}{currencySymbol}
                       
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Transport Allowance</th>
                        <td className="p-3">{parseFloat(value.transport_allowance).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Meal Allowance</th>
                        <td className="p-3">{parseFloat(value.meal_allowance).toFixed(2)}{currencySymbol}</td>
                      </tr>
                     
                   
                      <tr>
                        <th className="p-3">Imcome Tax Deduction</th>
                        <td className="p-3">{parseFloat(value.income_tax_deduction).toFixed(2)}{currencySymbol}</td>
                      </tr>
                     
                   
                     
                      <tr>
                        <th className="p-3">Payment Method</th>
                        <td className="p-3">{value.payment_method}</td>
                      </tr>
                     
                     
                      <tr>
                        <th className="p-3">Number Of Children</th>
                        <td className="p-3">{value.number_of_children}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Equipe</th>
                        <td className="p-3">{value.equipe}</td>
                      </tr>
                     
                     
                      <tr>
                        <th className="p-3">Seniority</th>
                        <td className="p-3">{value.seniority}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">RIB</th>
                        <td className="p-3">{value.rib}</td>
                      </tr>
                      <tr>
                        <th className="p-3">CIN</th>
                        <td className="p-3">{value.cin}</td>
                      </tr>
                      <tr>
                        <th className="p-3">CNSS Status</th>
                        <td className="p-3">{value.cnss_status && value.cnss_status == 1 ? 'Déclaré(e)' : 'Non - Déclaré(e)'}</td>
                      </tr>
                      <tr>
                        <th className="p-3">CNSS Number</th>
                        <td className="p-3">{value.cnss}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Matricule</th>
                        <td className="p-3">{value.matricule}</td>
                      </tr>
                     

                      <tr>
                        <th className="p-3">Address</th>
                        <td className="p-3">{value.address}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Status</th>
                        <td className="p-3">{value.status}</td>
                      </tr>
                    
                    </table>
                    <br />
                    <h5 className="card-title"> Documents</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Document Name</th>
                              <th className="p-3">Document Attached</th>

                        </tr>
                        </thead>
                      <tbody>
                        {value.documents &&
                          value.documents.map((doc, index) => (
                            <tr  key={doc.id || index}>
                              <td className="p-3">{doc.file_name}</td>
                              <td className="p-3">
                              {doc.link && (
                                  <a
                                    className="btn btn-primary"
                                    href={viewFile(doc.link)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                  >
                                    Download
                                  </a>
                                )}

                              
                            </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    <br />
                    <h5 className="card-title">Allowances</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Allowance Type</th>
                              <th className="p-3">Amount </th>
                        </tr>
                        </thead>
                      <tbody>
                      {value.emp_allowances &&
                          value.emp_allowances.map((allowance, index) => (
                            <tr key={allowance.id || index}>
                              {/* <td className="p-3">{allowance.title}</td> */}
                              <td className="p-3">
                                    {allowance.title === "Other"
                                      ? allowance.other_type  
                                      : allowance.title}      
                                  </td>
                              <td className="p-3">{allowance.amount}({currencySymbol})</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ExpenseView;
